export enum PlayerStatus {
  Playing, Paused, Loading, Error
}